import { render } from "./AppInputNumber.vue?vue&type=template&id=16e40e63&scoped=true"
import script from "./AppInputNumber.vue?vue&type=script&lang=js"
export * from "./AppInputNumber.vue?vue&type=script&lang=js"

import "./AppInputNumber.vue?vue&type=style&index=0&id=16e40e63&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e40e63"]])

export default __exports__